import {
    FETCH_CANT_ANSWER_VISUALIZATION_START,
    FETCH_CANT_ANSWER_VISUALIZATION_SUCCESS,
    FETCH_CANT_ANSWER_VISUALIZATION_FAIL,

} from "../../../constants";
import {
    FETCH_CANT_ANSWER_VISUALIZATION_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getCantAnswerResponses = createVisualizationFetchAction(FETCH_CANT_ANSWER_VISUALIZATION_URL, {
    START: FETCH_CANT_ANSWER_VISUALIZATION_START,
    SUCCESS: FETCH_CANT_ANSWER_VISUALIZATION_SUCCESS,
    FAIL: FETCH_CANT_ANSWER_VISUALIZATION_FAIL,
});

